
import { useSignIn } from "./auth/useSignIn";
import { useSignUp } from "./auth/useSignUp";
import { useVerification } from "./auth/useVerification";
import { useSignOut } from "./auth/useSignOut";

export const useAuthActions = () => {
  const { signIn } = useSignIn();
  const { signUp } = useSignUp();
  const { verifyOtp, resendVerificationEmail } = useVerification();
  const { signOut } = useSignOut();

  return {
    signIn,
    signUp,
    verifyOtp,
    resendVerificationEmail,
    signOut
  };
};
